/* import __COLOCATED_TEMPLATE__ from './testimonial-list-item.hbs'; */
import Component from '@glimmer/component';

export default class TestimonialListItemComponent extends Component {}
